import { type SvgIconProps } from '@common/components/svgs/props';

function IconFeedbackSent(props: Readonly<SvgIconProps>) {
  return (
    <svg
      {...props}
      width="144"
      height="144"
      viewBox="0 0 144 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-FeedbackSentIcon"
    >
      <rect x="20.5" y="39.5" width="105" height="73" rx="1.5" fill="#EDEDED" stroke="#EDEDED" />
      <path d="M21 43H125V52.5L73 83L21 52.5V43Z" fill="black" fillOpacity="0.08" />
      <path d="M21 40H125V49.5L73 80L21 49.5V40Z" fill="#F5F5F5" />
      <rect x="27" y="92" width="12" height="14" fill="#BA0C2F" fillOpacity="0.2" />
      <circle cx="39.5" cy="91.5" r="8" stroke="#5889E9" />
      <circle cx="39.5" cy="91.5" r="5" stroke="#5889E9" />
      <circle cx="115" cy="50" r="23" fill="#007A46" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.562 60.1863L112.486 60.2619L104.043 51.8184L106.164 49.6971L112.562 56.0949L125.864 42.793L127.985 44.9143L112.638 60.2619L112.562 60.1863Z"
        fill="white"
      />
    </svg>
  );
}

IconFeedbackSent.displayName = 'FeedbackSent';

export default IconFeedbackSent;
